import { ServiceType } from '../types';

const SERVICE_PATH_MAPPINGS: Record<ServiceType, string[]> = {
  yozmit: ['/magazine'],
  superstack: ['/superstack'],
  trim: ['/admin'],
  project: ['/project/free-consulting'],
  partner: ['/partner/'], // /partners/ 도 startWith 체크에 걸려서 slash 추가
  solution: ['/store/wishket-packages'],
  support: ['/customer-support', '/company-intro', '/trust-safety'],
  profile: ['/profile'],
  wishket: [],
  'wishket-member': [],
};

/**
 * URL 인코딩된 경로를 디코드하여 원본 경로와 비교
 */
const normalizeEncodedPath = (path: string): string => {
  try {
    return decodeURIComponent(path);
  } catch {
    return path;
  }
};

/**
 * 경로가 패턴 중 하나로 시작하는지 확인
 */
const pathStartsWith = (path: string, patterns: string[]): boolean => {
  const normalizedPath = normalizeEncodedPath(path);
  return patterns.some(
    (pattern) => normalizedPath.startsWith(pattern) || path.startsWith(pattern)
  );
};

const getReferrerService = (next: string): ServiceType => {
  if (!next) return 'wishket-member';

  for (const [service, patterns] of Object.entries(SERVICE_PATH_MAPPINGS)) {
    if (patterns.length > 0 && pathStartsWith(next, patterns)) {
      return service as ServiceType;
    }
  }

  return 'wishket';
};

export default getReferrerService;
